// WILLIAMS Golf Therapy — Datos del Plan de Negocios (Español / Spanish)
// Latin-American Spanish · Tono profesional para inversionistas

export const BRAND = {
  name: "WILLIAMS Golf Therapy",
  tagline: "El Futuro del Rendimiento Integral en el Golf",
  pillars: "Mente  •  Cuerpo  •  Swing  •  Recuperación",
  vision:
    "Un ecosistema completo de rendimiento en golf — donde terapia, recuperación, entrenamiento y psicología se unen para que el golfista juegue mejor, por más tiempo y sin dolor.",
};

export const LOCATION = {
  address: "Biscayne Boulevard, Miami Shores, Florida",
  proximity: "a media milla del Miami Shores Country Club",
  squareFeet: "4,900 pies cuadrados (≈455 m²)",
  trafficCount: "60,000+",
  trafficNote: "vehículos circulan a diario y de noche por Biscayne Blvd",
};

export const FOUNDER = {
  name: "William Márquez",
  experience: "Más de 30 años",
  credentials: [
    "Miembro de la USGA desde 1994",
    "Fisioterapeuta titulado — especialista en Medicina Deportiva",
    "Red de instructores afiliados a la PGA",
    "Miembro del Miami Shores Country Club",
    "Miembro del Consejo — Church by the Sea",
    "Miembro del Rotary Club",
    "Capítulo Florida — Entrenamiento de golf para personas con discapacidad física",
  ],
};

export const MARKET = {
  golfers: {
    miamiDade: 39960,
    broward: 29300,
    palmBeach: 28000,
    get total() { return this.miamiDade + this.broward + this.palmBeach; },
  },
  courses: { miamiDade: 40, broward: 35, palmBeach: 30, get total() { return this.miamiDade + this.broward + this.palmBeach; } },
  perLocationCapture: 0.29,
  fullFranchiseCapture: 1.03,
};

export const MEMBERSHIP = {
  cap: 200,
  priceMonthly: 320,
  get monthlyMembershipRevenue() { return this.cap * this.priceMonthly; },
};

export const MONTHLY_REVENUE = {
  membership: 64000,
  performancePackages: 5000,
  insuranceReimbursement: 3000,
  ancillary: 3000,
  get total() { return this.membership + this.performancePackages + this.insuranceReimbursement + this.ancillary; },
};

export const MONTHLY_OPEX = {
  baseRentNNN: 20900,
  payroll: 15000,
  marketing: 5000,
  utilitiesInternet: 1200,
  suppliesLaundry: 800,
  professionalServices: 500,
  insurance: 400,
  loanPayment: 5400,
  get total() {
    return this.baseRentNNN + this.payroll + this.marketing + this.utilitiesInternet + this.suppliesLaundry + this.professionalServices + this.insurance + this.loanPayment;
  },
};

export const STARTUP_CAPITAL = {
  items: [
    { label: "Depósitos de Arrendamiento (2 meses)", amount: 47366 },
    { label: "Construcción y Permisos", amount: 35000 },
    { label: "Equipos y Tecnología", amount: 55000 },
    { label: "Branding y Señalización", amount: 10000 },
    { label: "Marketing y Lanzamiento", amount: 15000 },
    { label: "Reserva de Nómina (3 meses)", amount: 30000 },
    { label: "Seguros, Legales, Licencias", amount: 8000 },
    { label: "Capital de Trabajo (60–90 días)", amount: 20000 },
    { label: "Contingencia / Reserva de Inversión", amount: 79634 },
  ],
  total: 300000,
};

export const PROJECTIONS = [
  { year: "Año 1", members: 110, occupancy: "55%", revenue: 420000, opex: 570000, netProfit: -150000, note: "Lanzamiento y ramp-up" },
  { year: "Año 2", members: 165, occupancy: "82%", revenue: 685000, opex: 590000, netProfit: 95000, note: "Punto de equilibrio cruzado a mitad de año" },
  { year: "Año 3", members: 200, occupancy: "100% + lista de espera", revenue: 900000, opex: 605000, netProfit: 295000, note: "Capacidad total • Documentación de franquicia inicia" },
  { year: "Año 4", members: 200, occupancy: "100% + 2 franquicias", revenue: 1850000, opex: 1360000, netProfit: 490000, note: "Apertura Ubicaciones 2–3 (Coral Gables, Ft. Lauderdale)" },
  { year: "Año 5", members: 200, occupancy: "100% + 4 franquicias", revenue: 3650000, opex: 2540000, netProfit: 1110000, note: "Apertura Ubicaciones 4–5 (Boca Raton, Palm Beach)" },
];

export const YEAR3_NET_AFTER_DEBT_TAX = 190000;

export const EQUITY = {
  structure: [
    { holder: "William Márquez (Fundador y Operador)", percent: 80 },
    { holder: "Grupo de Inversionistas", percent: 20 },
  ],
  finderFee: {
    label: "Comisión de Intermediación",
    description:
      "Comisión única pagada a facilitadores del levantamiento de capital — 10% del capital recaudado ($30,000 sobre una ronda de $300K). No es participación accionaria.",
    amountOnSeed: 30000,
  },
  totalCheck: 100,
};

export const INVESTMENT_OPTIONS = [
  {
    title: "Préstamo Convertible",
    terms: "5 años al 8% de interés",
    description: "Ingreso por interés fijo con opción de conversión a equity en evento de venta de la franquicia. Camino de menor riesgo.",
    ideal: "Inversionistas orientados a ingreso",
  },
  {
    title: "Participación Accionaria",
    terms: "20% de participación",
    description: "Equity directo en la LLC del prototipo. Pago de salida al vender la franquicia (Año 5–7). Distribuciones proporcionales.",
    ideal: "Inversionistas orientados a crecimiento",
  },
  {
    title: "Sociedad Estratégica",
    terms: "Deuda + equity combinados",
    description: "Estructura híbrida con compromiso de financiamiento para expansión y rol activo en desarrollo de franquicias y selección de ubicaciones.",
    ideal: "Socios operadores / operadores multi-unidad",
  },
];

export const EXIT_SCENARIOS = [
  { sale: 10000000, founder: 8000000, investors: 2000000, multiple: "6.7×" },
  { sale: 12000000, founder: 9600000, investors: 2400000, multiple: "8.0×" },
  { sale: 15000000, founder: 12000000, investors: 3000000, multiple: "10.0×" },
];

export const SERVICES = [
  {
    title: "Medicina Deportiva",
    icon: "stethoscope",
    image: "/brand/svc-sports-med.jpg",
    bullets: [
      "Evaluación ortopédica y articular",
      "Terapia manual y punción seca",
      "Terapia de ondas de choque y láser",
      "Protocolos de tratamiento de grado médico",
    ],
  },
  {
    title: "Rehabilitación",
    icon: "activity",
    image: "/brand/svc-rehab-massage.jpg",
    bullets: [
      "Programas de retorno al golf post-quirúrgicos",
      "Recuperación de lesiones (manguito rotador, cadera, lumbar, codo)",
      "Re-patrón de movimiento",
      "Servicios de fisioterapia facturables al seguro",
    ],
  },
  {
    title: "Acondicionamiento Físico",
    icon: "dumbbell",
    image: "/brand/svc-fitness-mobility.jpg",
    bullets: [
      "Entrenadores certificados en fuerza y acondicionamiento",
      "Programas de movilidad y flexibilidad",
      "Entrenamiento de balance con plataformas de fuerza",
      "Suite de recuperación (inmersión fría, compresión, sauna)",
    ],
  },
  {
    title: "Nutrición",
    icon: "apple",
    image: "/brand/svc-nutrition.jpg",
    bullets: [
      "Planes de nutrición deportiva",
      "Protocolos de hidratación y alimentación en cancha",
      "Análisis de composición corporal (InBody)",
      "Suplementación y productos de recuperación",
    ],
  },
  {
    title: "Psicología Deportiva",
    icon: "brain",
    image: "/brand/svc-sports-psych.jpg",
    bullets: [
      "Coaching de rendimiento mental",
      "Entrenamiento en enfoque, compromiso, proceso y resiliencia",
      "Rutina pre-tiro y mentalidad competitiva",
      "Visualización, respiración y protocolos de confianza",
    ],
  },
  {
    title: "Coaching",
    icon: "trophy",
    image: "/brand/svc-coaching-band.jpg",
    bullets: [
      "Instrucción afiliada a la PGA",
      "Análisis biomecánico del swing",
      "Juego corto y estrategia en cancha",
      "Programas de desarrollo juvenil y longevidad senior",
    ],
  },
  {
    title: "Tecnología de Golf",
    icon: "radar",
    image: "/brand/tech-trackman.jpg",
    bullets: [
      "Monitor de lanzamiento TrackMan 4",
      "Simuladores Full Swing / Foresight GCQuad",
      "Biomecánica 3D K-Vest / HackMotion",
      "Mapeo de presión BodiTrak y plataformas de fuerza",
    ],
  },
];

export const HERO_BG = "/brand/signage-night.jpg";

export const FOUNDER_IMAGES = {
  primary: "/brand/founder-putting-green.jpg",
  secondary: "/brand/founder-mountain.jpg",
};

export const FACILITY_GALLERY = [
  {
    image: "/brand/renderings-split.jpg",
    eyebrow: "La Visión",
    title: "Concepto Día y Noche",
    text: "Renders arquitectónicos del flagship en Biscayne Blvd — Mente · Cuerpo · Swing · Recuperación integrados al edificio mismo.",
  },
  {
    image: "/brand/storefront-day.jpg",
    eyebrow: "La Construcción",
    title: "Fachada Comercial",
    text: "Entrada con el emblema de WILLIAMS Golf Therapy — un ecosistema completo de rendimiento, evidente desde la puerta.",
  },
  {
    image: "/brand/signage-night.jpg",
    eyebrow: "Presencia de Marca",
    title: "Señalización Iluminada",
    text: "Señalización de alta visibilidad que activa los 60,000+ vehículos diarios en Biscayne Blvd — día y noche.",
  },
  {
    image: "/brand/location-biscayne.jpg",
    eyebrow: "El Sitio",
    title: "Biscayne Boulevard, Miami Shores",
    text: "El sitio actual — Biscayne Plaza, a ½ milla del Miami Shores Country Club. El flagship comienza aquí.",
  },
];

export const FRANCHISE_ROADMAP = [
  { phase: "Año 1", milestone: "Flagship Miami Shores", detail: "Lanzamiento del prototipo, validación de marca, línea base de KPI" },
  { phase: "Año 2", milestone: "Prueba de Concepto", detail: "Métricas de membresía validadas, documentos legales de franquicia (FDD) preparados" },
  { phase: "Año 3", milestone: "Listo para Franquiciar", detail: "Manual de operaciones finalizado, capacidad total en flagship" },
  { phase: "Año 4", milestone: "Ubicaciones 2 y 3", detail: "Corredores Coral Gables + Fort Lauderdale" },
  { phase: "Año 5", milestone: "Ubicaciones 4 y 5", detail: "Boca Raton + Palm Beach — corredor completo" },
  { phase: "Años 6–7", milestone: "Salida / Escala", detail: "Venta estratégica, master-franquicia regional, o consolidación PE" },
];

export const DIFFERENTIATORS = [
  {
    title: "El Único Modelo Integrado en el Sur de Florida",
    text: "Los competidores ofrecen terapia O coaching O fitness O tecnología — nunca bajo un mismo techo, una membresía, un mismo historial clínico.",
  },
  {
    title: "Capa de Ingresos Facturable al Seguro",
    text: "Los servicios de fisioterapia con licencia generan reembolsos del seguro encima de las membresías — un flujo de ingresos que ninguna academia tradicional de golf puede acceder.",
  },
  {
    title: "Zona de Captación Cautiva y de Alto Ingreso",
    text: "60,000+ vehículos diarios en Biscayne Blvd; a ½ milla del Miami Shores CC; minutos de Bay Point, Belle Meade e Indian Creek.",
  },
  {
    title: "Diseñado para Franquiciar Desde el Día Uno",
    text: "Cada sistema — desde admisión hasta programación y facturación — está construido para ser replicado. El flagship es el manual.",
  },
];

export const WHY_NOW = [
  "La participación post-pandemia en el golf está en su máximo en 20 años (NGF 2025).",
  "Bienestar + longevidad es la categoría de consumo de más rápido crecimiento en el Sur de Florida.",
  "El reembolso del seguro por fisioterapia deportiva se expandió bajo las regulaciones CMS 2024–25.",
  "La tecnología de golf (TrackMan, Foresight, biomecánica) ya es mainstream — y esperada por el consumidor.",
  "Ningún competidor en el corredor Miami Shores → Palm Beach ofrece el modelo integrado.",
];

export const HERO_KPIS = [
  { label: "Capital Semilla", value: "$300K", sub: "Convertible / Equity / Híbrido" },
  { label: "Ingresos Año 3", value: "$900K", sub: "200 miembros a capacidad total" },
  { label: "Ingresos Año 5", value: "$3.65M", sub: "Suma de 5 ubicaciones" },
  { label: "Retorno Objetivo", value: "11–13×", sub: "Horizonte 5–7 años" },
];

export const CONTACT = {
  email: "williamsgolftherapy@gmail.com",
  phone: "786-222-0533",
  phoneTel: "+17862220533",
  address: "Biscayne Boulevard, Miami Shores, Florida",
  founder: "William Márquez, Fundador",
};

export const INVESTOR_CTA = {
  href: `mailto:${"williamsgolftherapy@gmail.com"}?subject=${encodeURIComponent("Consulta de Inversionista — WILLIAMS Golf Therapy")}&body=${encodeURIComponent("Hola William,\n\nMe gustaría conocer más sobre la oportunidad de inversión en la franquicia WILLIAMS Golf Therapy. Por favor comparta los próximos pasos para una llamada de 30 minutos.\n\nSaludos cordiales,\n")}`,
  label: "Agendar Llamada con Inversionista",
  sub: "Sesión privada de 30 minutos con William Márquez",
};

export const COMPARISON = {
  competitors: ["WILLIAMS Golf Therapy", "TPI Institute", "GolfTec", "Fisioterapia Tradicional"],
  rows: [
    { feature: "Medicina Deportiva (interna)",        values: ["full",    "cert-only", "none",    "full"] },
    { feature: "Rehabilitación / Fisioterapia",       values: ["full",    "referral",  "none",    "full"] },
    { feature: "Fuerza y Acondicionamiento",          values: ["full",    "partner",   "none",    "limited"] },
    { feature: "Nutrición Deportiva",                  values: ["full",    "none",      "none",    "none"] },
    { feature: "Coaching afiliado a PGA",              values: ["full",    "referral",  "full",    "none"] },
    { feature: "Tecnología de Golf (TrackMan, sims)", values: ["full",    "none",      "partial", "none"] },
    { feature: "Reembolso del Seguro",                 values: ["full",    "none",      "none",    "full"] },
    { feature: "Membresía Única Unificada",            values: ["full",    "n/a",       "per lesson", "per visit"] },
    { feature: "Historial Integral del Miembro",       values: ["full",    "none",      "none",    "limited"] },
    { feature: "Psicología Deportiva / Mental",        values: ["full",    "partner",   "none",    "none"] },
  ],
};

// ---- UI Labels (section titles, buttons, etc.) ----
export const UI = {
  nav: {
    investorBusinessPlan: "Plan de Negocios para Inversionistas",
    downloadPdf: "Descargar PDF",
    items: { vision: "Visión", market: "Mercado", services: "Servicios", financials: "Finanzas", investment: "Inversión", roadmap: "Hoja de Ruta", contact: "Contacto" },
  },
  hero: { eyebrow: "Prototipo de Franquicia · Memorándum de Inversión" },
  founder: {
    title: "El Fundador",
    kicker: "30+ años de medicina deportiva clínica y rendimiento en golf — una mezcla única de practicante médico, golfista certificado por la USGA y líder comunitario.",
    whyTitle: "Por qué este Fundador, por qué ahora",
    whyText:
      "El modelo integrado solo funciona cuando un mismo operador puede hablar el idioma de la ortopedia, biomecánica, coaching y negocios en la misma mesa. William ha dedicado tres décadas a hacer exactamente eso — ganándose la confianza de pacientes, miembros de country clubs, aseguradoras y la red de la PGA.",
    photoLabel: "Fundador y Operador",
  },
  market: {
    eyebrow: "Oportunidad de Mercado",
    title: "Un punto de apoyo defendible en el corredor del golf del Sur de Florida",
    kicker: "El corredor Miami Shores → Palm Beach concentra la mayor densidad de golfistas activos, country clubs y hogares de alto ingreso del estado.",
    miamiDadeLabel: "Golfistas Miami-Dade",
    browardLabel: "Golfistas Broward",
    palmBeachLabel: "Golfistas Palm Beach",
    coursesNote: (n) => `${n}+ canchas`,
    totalLabel: "Total de Golfistas Direccionables",
    totalNote: (n) => `En ${n}+ canchas de golf — la mayor concentración de golfistas pagantes del sureste de EE.UU.`,
    shareLabel: "Participación de Mercado Requerida",
    perSite: "por ubicación (200 miembros)",
    fullRollout: "rollout completo de 5 franquicias",
    shareCaption: "Capturar aproximadamente 1 de cada 100 golfistas del área llena todo el sistema de franquicias — un objetivo conservador y alcanzable.",
    locationTitle: "Ubicación",
    squareFeetLabel: "Pies Cuadrados",
    countryClubLabel: "Country Club",
    trafficLabel: "Tráfico Diario",
    visibilityLabel: "Visibilidad",
    dayNight: "Día y Noche",
    vehiclesUnit: "vehículos",
  },
  diff: { eyebrow: "Lo que nos distingue", title: "El único ecosistema integrado de rendimiento en golf del Sur de Florida" },
  comparison: {
    eyebrow: "Panorama Competitivo",
    title: "Siete categorías. Un solo operador entrega las siete.",
    kicker: "Cada operador comparable del mercado del Sur de Florida se especializa en solo una o dos de las disciplinas. Ninguno ofrece el modelo de membresía integrado.",
    capability: "Capacidad",
    footnote: "Comparativo basado en ofertas públicas y modelos operativos estándar al 2026. TPI = Titleist Performance Institute.",
    cellLabels: { full: "Completo", partial: "Parcial", referral: "Referido", limited: "Limitado", partner: "Aliado", "cert-only": "Solo cert.", none: "Ninguno", "n/a": "n/d", "per lesson": "Por clase", "per visit": "Por visita" },
  },
  facility: {
    eyebrow: "Realización de Marca",
    title: "Del render a la realidad — el flagship toma forma.",
    kicker: "Concepto arquitectónico, construcción con marca y presencia en la avenida — diseñados para convertir 60,000+ impresiones diarias en Biscayne Blvd en miembros.",
  },
  services: {
    eyebrow: "Líneas de Servicio",
    title: "Siete pilares. Una membresía. Un historial.",
    kicker: "Los miembros se mueven libremente entre todas las líneas de servicio bajo un solo programa — eliminando la fragmentación que define a cada competidor en la región.",
  },
  financials: {
    eyebrow: "Resumen Financiero",
    title: "Números conciliados. Tope de 200 miembros. Ramp-up realista.",
    kicker: "Todas las proyecciones reflejan el tope corregido de 200 miembros a $320/mes, más paquetes de rendimiento, reembolso de seguros e ingresos auxiliares.",
    monthlyRevenue: "Ingresos Mensuales a Capacidad Total",
    revenue: { membership: "Membresías (200 × $320)", performance: "Paquetes de rendimiento y adicionales", insurance: "Reembolso del seguro (Fisioterapia)", ancillary: "Auxiliares (pro-shop, nutrición, fittings)", total: "Total Ingresos Mensuales" },
    monthlyOpex: "Gastos Operativos Mensuales",
    opex: { rent: "Renta base + NNN", payroll: "Nómina (PTs, recepción, asistentes)", marketing: "Marketing (digital, local, referidos)", utilities: "Servicios e internet", supplies: "Insumos y lavandería", professional: "Servicios profesionales", insurance: "Seguros (RC + malpráctica)", loan: "Pago del préstamo ($300K @ 8% / 5 años)", total: "Total Gastos Operativos Mensuales" },
    netProfitMonthly: "Utilidad Mensual Neta (a capacidad)",
    operatingMargin: "Margen Operativo",
    year3Net: "Utilidad Neta Año 3 (después de deuda + impuestos)",
    startupAlloc: "Asignación del Capital Inicial",
    totalCapital: "Capital Total Requerido",
    useOfFunds: "Uso de Fondos (Visual)",
    projectionTitle: "Proyección a 5 Años (Flagship + Despliegue de Franquicias)",
    tableHead: { year: "Año", members: "Miembros / Ubicaciones", revenue: "Ingresos", opex: "OpEx", net: "Utilidad Neta", milestone: "Hito" },
    membersUnit: "miembros",
    tableFootnote: "Año 1 refleja período de lanzamiento y ramp-up; punto de equilibrio cruzado en Q2 del Año 2. Utilidad Año 3 (después de deuda e impuestos) corresponde solo al flagship.",
    chartEyebrow: "Trayectoria de Crecimiento",
    chartTitle: "Ingresos y Utilidad Neta a 5 Años",
    chartLegendRevenue: "Ingresos",
    chartLegendProfit: "Utilidad Neta",
    chartFootnote: "Año 1 refleja el lanzamiento del flagship y ramp-up. Punto de equilibrio cruzado a mitad del Año 2. Años 4–5 reflejan ingresos acumulados a través de franquicias activas.",
  },
  investment: {
    eyebrow: "Estructura de Inversión",
    title: "Tres caminos de entrada. Una franquicia de salida.",
    kicker: "Estructuras flexibles para socios de capital. El equity totaliza 100%. La Comisión de Intermediación es un pago único sobre el capital recaudado — no participación accionaria.",
    capTable: "Tabla de Capitalización (Post-Semilla)",
    totalEquity: "Equity Total",
    finderFeeAmount: "10% del capital recaudado",
    onSeed: "Sobre la ronda semilla de $300K",
    feeAmount: "comisión única",
    idealFor: "Ideal para:",
    exitTitle: "Escenarios de Salida (Años 5–7)",
    exitSub: "Venta estratégica o master-franquicia regional — retornos proyectados por precio de venta.",
    exitTable: { salePrice: "Precio de Venta", founder: "Fundador (80%)", investors: "Inversionistas (20%)", multiple: "Múltiplo del inversionista sobre $300K" },
  },
  roadmap: {
    eyebrow: "Hoja de Ruta de Franquicias",
    title: "5 ubicaciones. Miami Shores → Palm Beach. 5–7 años.",
    kicker: "El flagship valida el modelo. Los Años 4–5 despliegan 4 ubicaciones adicionales hacia el norte por el corredor de golf más adinerado de Florida.",
  },
  whyNow: { eyebrow: "Por Qué Ahora", title: "Cinco fuerzas convergiendo — solo brevemente." },
  contact: {
    eyebrow: "Contáctenos",
    title: "Conversemos sobre la oportunidad.",
    kicker: "Comuníquese directamente con William Márquez para programar una conversación privada de inversionista o un recorrido por el flagship en Miami Shores.",
    emailLabel: "Email",
    phoneLabel: "Teléfono",
    visitLabel: "Visite",
    emailHint: "Click para componer y copiar dirección",
    phoneHint: "Click para llamar y copiar número",
    toastEmail: "Dirección de email copiada",
    toastPhone: "Número de teléfono copiado",
    quote: "Construyamos juntos el futuro del rendimiento integrado en el golf.",
  },
  footer: { pillars: "Mente · Cuerpo · Swing · Recuperación", inquiries: "Consultas de Inversionistas", confidential: "Memorándum confidencial para inversionistas." },
  common: { tomembers: "mbrs", break_even: "ramp-up · break-even" },
};
